/* eslint-disable react-hooks/exhaustive-deps */
// import React, { useEffect, useRef, useState } from "react";
// import { useFetchAccessCenter } from "../../../apis/profileApis";

// type ActionType = "create" | "read" | "update" | "delete";

// type PermissionItem = {
//   id: string;
//   name: string;
//   key: string;
//   actions: Record<ActionType, boolean>;
// };

// type PermissionMatrixProps = {
//   register: any;
//   errors: any;
//   setValue?: (field: string, value: any) => void;
//   defaultPermissions?: { dashboard: string; operations: ActionType[] }[];
//   readOnly?: boolean;
// };

// const PermissionMatrix: React.FC<PermissionMatrixProps> = ({
//   register,
//   errors,
//   setValue,
//   defaultPermissions = [],
//   readOnly = false,
// }) => {
//   const { data: accessCenter } = useFetchAccessCenter();
//   const [permissions, setPermissions] = useState<PermissionItem[]>([]);
//   const selectAllRefs = useRef<(HTMLInputElement | null)[]>([]);

//   // Initialize from API
//   useEffect(() => {
//     if (accessCenter && accessCenter.length > 0) {
//       const initialized = accessCenter.map((item: any) => ({
//         id: item.id,
//         name: item.name,
//         key: item.key,
//         actions: {
//           create: false,
//           read: false,
//           update: false,
//           delete: false,
//         },
//       }));
//       setPermissions(initialized);
//     }
//   }, [accessCenter]);

//   // Apply defaultPermissions
//   useEffect(() => {
//     if (permissions.length > 0 && defaultPermissions.length > 0) {
//       const updated = permissions.map((perm) => {
//         const matched = defaultPermissions.find(
//           (dp) => dp.dashboard === perm.key || dp.dashboard === perm.name
//         );
//         if (matched) {
//           const newActions = { ...perm.actions };
//           matched.operations.forEach((op) => {
//             if (op in newActions) newActions[op] = true;
//           });
//           return { ...perm, actions: newActions };
//         }
//         return perm;
//       });
//       setPermissions(updated);
//     }
//   }, [permissions.length, defaultPermissions]);

//   // Indeterminate state for "Select All"
//   useEffect(() => {
//     permissions.forEach((section, idx) => {
//       const ref = selectAllRefs.current[idx];
//       if (!ref) return;

//       const values = Object.values(section.actions);
//       const allTrue = values.every(Boolean);
//       const someTrue = values.some(Boolean);

//       ref.checked = allTrue;
//       ref.indeterminate = !allTrue && someTrue;
//     });
//   }, [permissions]);

//   // Form registration
//   useEffect(() => {
//     const transformed = permissions
//       .filter((p) => Object.values(p.actions).some(Boolean))
//       .map((p) => ({
//         dashboard: p.key,
//         operations: Object.entries(p.actions)
//           .filter(([, val]) => val)
//           .map(([key]) => key as ActionType),
//       }));

//     setValue?.("permissions", transformed);
//     register("permissions", {
//       validate: (value: any) => value?.length > 0 || "At least one permission is required",
//     });
//   }, [permissions, setValue, register]);

//   const togglePermission = (index: number, action: ActionType) => {
//     if (readOnly) return;
//     const updated = [...permissions];
//     updated[index].actions[action] = !updated[index].actions[action];
//     setPermissions(updated);
//   };

//   const toggleSelectAll = (index: number, checked: boolean) => {
//     if (readOnly) return;
//     const updated = [...permissions];
//     updated[index].actions = {
//       create: checked,
//       read: checked,
//       update: checked,
//       delete: checked,
//     };
//     setPermissions(updated);
//   };

//   if (!permissions.length) {
//     return <div>Loading permissions...</div>;
//   }

//   return (
//     <div className="divide-y divide-[#000000]/10">
//       {permissions.map((section, idx) => (
//         <div key={section.id} className="mb-6 py-3 px-6 space-y-4">
//           <div className="flex items-center justify-between mb-2">
//             <h3 className="text-base font-medium text-[#212121]">
//               {section.name}
//             </h3>

//             <label className="flex items-center gap-1 cursor-pointer">
//               <label className="relative flex items-center">
//                 <input
//                   type="checkbox"
//                   ref={(el: any) => (selectAllRefs.current[idx] = el)}
//                   disabled={readOnly}
//                   onChange={(e) => toggleSelectAll(idx, e.target.checked)}
//                   className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] transition-all bg-white checked:bg-[#FBD037] checked:text-white"
//                 />
//                 <span className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
//                   ✓
//                 </span>
//               </label>
//               <span className="text-sm font-medium text-[#212121]"> Select All</span>
//             </label>
//           </div>

//           {/* Changed back to single column layout like original */}
//           <div className="grid grid-cols-1 gap-y-3">
//             {(["create", "read", "update", "delete"] as ActionType[]).map((action) => (
//               <label
//                 key={action}
//                 className="flex items-center gap-1 space-x-2 cursor-pointer"
//               >
//                 <label className="relative flex items-center">
//                   <input
//                     type="checkbox"
//                     disabled={readOnly}
//                     checked={section.actions[action]}
//                     onChange={() => togglePermission(idx, action)}
//                     className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] transition-all bg-white checked:bg-[#FBD037] checked:text-white"
//                   />
//                   <span className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
//                     ✓
//                   </span>
//                 </label>
//                 <span className="text-base text-[#212121] capitalize"> {action}</span>
//               </label>
//             ))}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default PermissionMatrix;

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useFetchAccessCenter } from "../../../apis/profileApis";
import { UseFormSetValue } from "react-hook-form";
import { T, useLanguage } from "../../../context/LanguageContext";

type ActionType = "create" | "read" | "update" | "delete";

type PermissionItem = {
  id: string;
  name: string;
  key: string;
  actions: Record<ActionType, boolean>;
};

type PermissionMatrixProps = {
  register: any;
  errors: any;
  setValue?: UseFormSetValue<any>;
  defaultPermissions?: { dashboard: string; operations: ActionType[] }[];
  readOnly?: boolean;
  allowedModules?: readonly string[];
};

const PermissionMatrix: React.FC<PermissionMatrixProps> = ({
  register,
  errors,
  setValue,
  defaultPermissions = [],
  readOnly = false,
  allowedModules,
}) => {
  const { t } = useLanguage();
  const { data: accessCenter } = useFetchAccessCenter();
  const [permissions, setPermissions] = useState<PermissionItem[]>([]);
  const selectAllRefs = useRef<Array<HTMLInputElement | null>>([]);
  const globalSelectAllRef = useRef<HTMLInputElement>(null);

  const visiblePermissions = allowedModules
    ? permissions.filter((p) => allowedModules.includes(p.key))
    : permissions;

  useEffect(() => {
    if (accessCenter && accessCenter.length > 0) {
      const initialized = accessCenter.map((item: any) => ({
        id: item.id,
        name: item.name,
        key: item.key,
        actions: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
      }));
      setPermissions(initialized);
    }
  }, [accessCenter]);

  useEffect(() => {
    if (permissions.length === 0 || defaultPermissions.length === 0) return;

    const updated = permissions.map((perm) => {
      const matched = defaultPermissions.find(
        (dp) => dp.dashboard === perm.key || dp.dashboard === perm.name,
      );
      if (matched) {
        const newActions = { ...perm.actions };
        matched.operations.forEach((op) => {
          if (op in newActions) newActions[op as ActionType] = true;
        });
        return { ...perm, actions: newActions };
      }
      return perm;
    });

    setPermissions(updated);
  }, [defaultPermissions, permissions.length]);

  useEffect(() => {
    visiblePermissions.forEach((section, idx) => {
      const ref = selectAllRefs.current[idx];
      if (!ref) return;

      const values = Object.values(section.actions);
      const allTrue = values.every(Boolean);
      const someTrue = values.some(Boolean);

      ref.checked = allTrue;
      ref.indeterminate = !allTrue && someTrue;
    });
  }, [permissions]);

  useEffect(() => {
    if (!globalSelectAllRef.current || readOnly) return;

    const allActions = visiblePermissions.flatMap((p) =>
      Object.values(p.actions),
    );
    const total = allActions.length;
    const checkedCount = allActions.filter(Boolean).length;

    const isFullyChecked = checkedCount === total && total > 0;
    const isPartiallyChecked = checkedCount > 0 && checkedCount < total;

    globalSelectAllRef.current.checked = isFullyChecked;
    globalSelectAllRef.current.indeterminate = isPartiallyChecked;
  }, [permissions, readOnly]);

  useEffect(() => {
    if (!setValue) return;

    const transformed = permissions
      .filter((p) => Object.values(p.actions).some(Boolean))
      .map((p) => ({
        dashboard: p.key,
        operations: Object.entries(p.actions)
          .filter(([, val]) => val)
          .map(([key]) => key as ActionType),
      }));

    setValue("permissions", transformed, { shouldValidate: true });
  }, [permissions, setValue]);

  useEffect(() => {
    register("permissions", {
      validate: (value: any) =>
        !value || value.length === 0
          ? "At least one permission is required"
          : true,
    });
  }, [register]);

  useEffect(() => {
    if (!setValue) return;

    const subscription = register("globalSelectAll", {
      onChange: (e: any) => {
        if (readOnly) return;
        const shouldSelect = !!e.target?.checked;

        setPermissions((prev) =>
          prev.map((section) => {
            if (allowedModules && !allowedModules.includes(section.key)) {
              return section;
            }
            return {
              ...section,
              actions: {
                create: shouldSelect,
                read: shouldSelect,
                update: shouldSelect,
                delete: shouldSelect,
              },
            };
          }),
        );
      },
    });

    return () => subscription.unsubscribe?.();
  }, [register, readOnly, setValue, allowedModules]);

  const togglePermission = (visibleIdx: number, action: ActionType) => {
    if (readOnly) return;
    const targetKey = visiblePermissions[visibleIdx].key;
    setPermissions((prev) =>
      prev.map((p) =>
        p.key === targetKey
          ? { ...p, actions: { ...p.actions, [action]: !p.actions[action] } }
          : p,
      ),
    );
  };

  const toggleSelectAll = (visibleIdx: number, checked: boolean) => {
    if (readOnly) return;
    const targetKey = visiblePermissions[visibleIdx].key;
    setPermissions((prev) =>
      prev.map((p) =>
        p.key === targetKey
          ? {
              ...p,
              actions: {
                create: checked,
                read: checked,
                update: checked,
                delete: checked,
              },
            }
          : p,
      ),
    );
  };

  if (!permissions.length) {
    return (
      <div className="p-6 text-center text-gray-500">
        <T>Loading permissions...</T>
      </div>
    );
  }

  return (
    <div className="divide-y divide-[#000000]/10">
      {visiblePermissions.map((section, idx) => (
        <div key={section.id} className="  py-3 px-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <label className="relative flex items-center">
                <input
                  type="checkbox"
                  ref={(el) => {
                    selectAllRefs.current[idx] = el;
                  }}
                  disabled={readOnly}
                  onChange={(e) => toggleSelectAll(idx, e.target.checked)}
                  className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] transition-all bg-white checked:bg-[#FBD037] checked:text-white indeterminate:bg-[#FBD037]/70 indeterminate:border-[#FBD037]/70"
                />
                <span className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                  ✓
                </span>
              </label>
              <h3 className="text-base font-medium text-[#212121]">
                <T>{section.name}</T>
              </h3>
            </div>

            <div className="grid grid-cols-4 gap-x-3">
              {(["create", "read", "update", "delete"] as ActionType[]).map(
                (action) => {
                  const isActive = section.actions[action];

                  if (readOnly) {
                    const colorMap = {
                      create: "bg-blue-100 text-blue-700",
                      read: "bg-green-100 text-green-700",
                      update: "bg-yellow-100 text-yellow-800",
                      delete: "bg-red-100 text-red-700",
                    };

                    return (
                      <span
                        key={action}
                        className={`px-3 py-1 rounded-full text-xs font-semibold tracking-wide border text-center ${
                          isActive
                            ? colorMap[action]
                            : "bg-gray-100 text-[#212121]/70"
                        }`}
                      >
                        {t(action).toUpperCase()}
                      </span>
                    );
                  }

                  return (
                    <label
                      key={action}
                      className="flex items-center gap-2 cursor-pointer"
                    >
                      <label className="relative flex items-center">
                        <input
                          type="checkbox"
                          disabled={readOnly}
                          checked={section.actions[action]}
                          onChange={() => togglePermission(idx, action)}
                          className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] transition-all bg-white checked:bg-[#FBD037]"
                        />
                        <span className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                          ✓
                        </span>
                      </label>
                      <span className="text-base text-[#212121] capitalize">
                        <T>{action}</T>
                      </span>
                    </label>
                  );
                },
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PermissionMatrix;
